import { render, staticRenderFns } from "./select-menu.vue?vue&type=template&id=5c3a7d5a&scoped=true"
import script from "./select-menu.vue?vue&type=script&lang=js"
export * from "./select-menu.vue?vue&type=script&lang=js"
import style0 from "./select-menu.vue?vue&type=style&index=0&id=5c3a7d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a7d5a",
  null
  
)

/* custom blocks */
import block0 from "./select-menu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports